"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ListingStoreFront_1 = require("./ListingStoreFront");
var ListingStoreFrontModel_1 = require("../model/ListingStoreFrontModel");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var UserAdminContext_1 = require("../../user/UserAdminContext");
var ListingMenuHelper_1 = require("./ListingMenuHelper");
var ListingNavHelper_1 = require("./ListingNavHelper");
var ListingStoreFrontApp = /** @class */ (function (_super) {
    __extends(ListingStoreFrontApp, _super);
    function ListingStoreFrontApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSelectItem = function (listing) {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings/" + listing.id });
        };
        _this._onOpen = function (listing) {
            _this.host.open({ path: "/ozone/listings/" + listing.id + "/launch", makeActive: true, title: listing.title });
        };
        _this._onLoad = function (listing) {
            _this.host.load({ path: "/ozone/listings/" + listing.id + "/launch", title: listing.title });
        };
        _this._onAdd = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings/add" });
        };
        _this._onOpenAllListings = function () {
            ListingNavHelper_1.pushAndLoad(_this.host, { path: "/ozone/listings" });
        };
        _this._onRefresh = function () {
            _this.listingStoreFront.refresh();
        };
        return _this;
    }
    Object.defineProperty(ListingStoreFrontApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingStoreFrontApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingStoreFrontApp.prototype, "listingStoreFront", {
        get: function () {
            return this.host.getState("listingStoreFront", function () {
                return new ListingStoreFrontModel_1.ListingStoreFrontModel();
            });
        },
        enumerable: true,
        configurable: true
    });
    ListingStoreFrontApp.prototype.componentWillMount = function () {
        this.host.setTitle("Store");
    };
    ListingStoreFrontApp.prototype.render = function () {
        var items = [];
        var backItem = ListingMenuHelper_1.createBackItem(this.host);
        if (backItem) {
            items.push(backItem);
        }
        if (UserAdminContext_1.UserAdminContext.value(this.userProfile)) {
            items.push({
                key: "listings",
                name: "All Listings",
                iconProps: {
                    iconName: "ViewList"
                },
                onClick: this._onOpenAllListings
            });
        }
        items.push({
            key: "add",
            title: "Add a new listing",
            iconProps: {
                iconName: "Add"
            },
            onClick: this._onAdd
        });
        var farItems = [
            {
                key: "refresh",
                title: !this.listingStoreFront.sync.syncing ? "Refresh listings" : "Refreshing...",
                iconProps: {
                    iconName: "Refresh"
                },
                onClick: this._onRefresh,
                disabled: this.listingStoreFront.sync.syncing
            }
        ];
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items, farItems: farItems } },
            React.createElement(ListingStoreFront_1.ListingStoreFrontContainer, { storeFront: this.listingStoreFront, onSelectItem: this._onSelectItem, onOpen: this._onOpen, onLoad: this._onLoad })));
    };
    ListingStoreFrontApp = __decorate([
        mobx_react_1.observer
    ], ListingStoreFrontApp);
    return ListingStoreFrontApp;
}(React.Component));
exports.ListingStoreFrontApp = ListingStoreFrontApp;
exports.default = ListingStoreFrontApp;
